import React from "react";
import { IPage } from "../../../../interfaces/models/models/paginated-response.model";
import { IPaginationPayload } from "../../../../interfaces/shared/IPaginationPayload";
import Table from "../../../../shared/table";
import moment from "moment";
import { ICalls } from "../../../../interfaces/reservations/ICalls";
import { useNavigate } from "react-router-dom";

const tableColumns = [
  "Call Id",
  "Call Started",
  "Summary",
  "Client Information",
  "Recording URL",
  "Actions",
];

interface IReservationDetails {
  rows: ICalls[];
  paginationData?: IPage;
  rowsLoading: boolean;
  setPaginationState: ({ pageNumber, pageSize }: IPaginationPayload) => void;
}

const CallsTable = ({
  rows,
  paginationData,
  rowsLoading,
  setPaginationState,
}: IReservationDetails) => {
  const navigate = useNavigate();

  const handleViewDetails = (id: string) => {
    navigate(`/calls/${id}`);
  };

  return (
    <Table
      columns={tableColumns}
      paginationData={paginationData}
      setPaginationState={setPaginationState}
    >
      {rowsLoading ? (
        <>
          {[...Array(4)].map((x, i) => {
            return (
              <tr key={i}>
                {[...Array(tableColumns?.length || 1)].map((x, j) => {
                  return (
                    <td key={j} className="td-1 !min-w-[100%] text-center py-5">
                      <span></span>
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </>
      ) : (
        <>
          {rows?.length > 0 &&
            rows?.map((row, idx: number) => {
              return (
                <tr key={idx} className="bg-white border-b hover:bg-gray-50">
                  <td className="px-5 py-4">
                    <div className="w-20 break-words">{row?._id}</div>
                  </td>
                  <td className="px-5 py-4">
                    {moment(row.otherData.callStarted).format(
                      "DD/MM/YYYY HH:mm"
                    )}
                  </td>
                  <td className="px-5 py-4" title={row.otherData.summary}>
					<div className="w-64">
						{row.otherData.summary.length > 200 ? String(row.otherData.summary).substring(0, 200) + '...' : row.otherData.summary}
					</div>
				  </td>

                  <td className="px-5 py-4">
                    {row.otherData.structuredData?.clientInformation && (
                      <>
                        {row.otherData.structuredData.clientInformation.name}{" "}
                        <br />
                        {
                          row.otherData.structuredData.clientInformation.email
                        }{" "}
                        <br />
                        {
                          row.otherData.structuredData.clientInformation
                            .phoneNumber
                        }
                      </>
                    )}
                  </td>
                  <td className="px-5 py-4">
                    <audio controls>
                      <source
                        src={row.otherData.recordingUrl}
                        type="audio/wav"
                      ></source>
                    </audio>
                  </td>
                  <td className="px-5 py-4">
                    <button
                      className=""
                      type="button"
                      onClick={() => handleViewDetails(row.callId)}
                    >
                      <img alt="info" src="/svg/layout/view.svg" />
                    </button>
                  </td>
                </tr>
              );
            })}
        </>
      )}
    </Table>
  );
};

export default CallsTable;
